export const ifacSecurityURL = process.env.REACT_APP_IFAC_SECURITY_URL;
export const FemsGraph = process.env.REACT_APP_FEMS_GRAPH_URL;
export const BemsGraph = process.env.REACT_APP_BEMS_GRAPH_URL;
export const MasterGraph = process.env.REACT_APP_MASTER_GRAPH_URL;
export const PowerBIURL = process.env.REACT_APP_POWER_BI_URL;
export const PowerBITitle = process.env.POWER_BI_TITLE;